import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dealer-verification-process/")({
  head: () => routeHead("/uk/dealer-verification-process/"),
  beforeLoad: () => {
    throw redirect({ href: "/incredere/verificare-dealeri", statusCode: 301, replace: true });
  },
});
